import {
  DownloadOutlined,
  GlobalOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { Select } from "antd";

export const TopBar = () => {
  const { t, i18n } = useTranslation();

  const onLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
  };
  return (
    <div>
      <div className="c-top">
        <div className="c-top__bar">
          <div className="c-top__bar-section-1">
            <div className="c-top__bar-section-content c-top__hoverglow">
              <DownloadOutlined className="c-top__bar-section-1-icon" />
              <div className="c-top__bar-section-1-title">
                {t("header.signing")}
              </div>
            </div>
          </div>
          <div className="c-top__bar-section-2">
            <div className="c-top__bar-section-content c-top__hoverglow">
              Watugot
            </div>
          </div>
          <div className="c-top__bar-section-3">
            <div className="c-top__bar-section-content ">
              <UserOutlined className="c-top__hoverglow" />
              <GlobalOutlined
                style={{ margin: "auto 16px auto 18px" }}
                className="c-top__hoverglow"
              />
              {i18n.languages && (
                <Select
                  className="c-top__hoverglow c-top__language-select"
                  onChange={onLanguageChange}
                  defaultValue={i18n.languages[0]}
                  options={i18n.languages.map((lan) => ({
                    value: lan,
                    label: lan.toUpperCase(),
                  }))}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
